import React, { useContext } from 'react';
import Switch from 'react-switch';
import MyContext from '../context/MyContext';

export default function SwitchLinguage() {
  const {
    language,
    setLanguage,
    checked,
    setChecked,
  } = useContext(MyContext);

  const handleChange = () => {
    switch (language) {
      case 'english':
        setLanguage('portuguese');
        setChecked(false);
        break;
      default:
        setLanguage('english');
        setChecked(true);
        break;
    }
  };

  return (
    <div className="switch">
      <span>pt-br</span>
      <Switch
        checked={checked}
        onChange={handleChange}
        onColor="#303030"
        offColor="#303030"
        onHandleColor="#fd7014"
        offHandleColor="#fd7014"
        handleDiameter={12}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1px 4px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 2px rgba(0, 0, 0, 0.2)"
        height={10}
        width={20}
        className="react-switch"
        id="material-switch"
      />
      <span>en-us</span>
    </div>
  );
}
